export const withCdn = (url: string) => {
  if (!url) return "";
  const cdnUrl = import.meta.env.VITE_CDN_URL as string;
  return /^https?:\/\//.test(url) ? url : `${cdnUrl}${url}`;
};

export const withoutCdn = (url: string) => {
  const cdnUrl = import.meta.env.VITE_CDN_URL as string;
  return url.replace(cdnUrl, "");
};
